module.exports = __webpack_public_path__ + "static/media/feat-tcr-img1.c3564d23.jpg";